<template>
    <div class="box">
        <Box title="派工">
            <FacilityDetails :data="EquipmentInfo"/>
            <Audio :AudioExternal='RepairInfo.AudioUrl'/>
            <RepairsDetails :data="RepairInfo"/>
            <div class="engineer">
                <p class="title">派工信息</p>
                <Field title="工程师" :action='true' name="personnel_maintain" @manuconfirm="AssignUserId=arguments[0].a" type="manufacturer" placeholder="请选择" />
            </div>
           <ImgModule upload :disabled='true'/>
        </Box>
        <Footer
            :button="[{text:'忽略',background:'#DEDEDE',color:'#858585',event: 'overlook'},{text:'派工',background:'#4FA69E',color:'#fff',event: 'dispatch'}]"
            @overlook="overlook"
            @dispatch="dispatch"
        />
    </div>
</template>

<script>
    import Audio from '../../components/Audio/AudioDefault.vue'
    import Box from '../../components/commonBox/commonBox'
    import Title from '../../components/commonTitle/commonTitle'
    import FacilityDetails from '../../components/facilityDetails/facilityDetails'
    import RepairsDetails from '../../components/repairsDetails/repairsDetails'
    import ImgModule from '../../components/imgModule/imgModule'
    import Footer from '../../components/footer/footer'
    import Field from '../../components/field/field'
    import Bus from '../../components/bus/bus'
    export default {
        name: 'Dispatch',
        components: {
            Audio,
            Box,
            Title,
            FacilityDetails,
            RepairsDetails,
            ImgModule,
            Footer,
            Field
        },
        data() {
            return {
                EquipmentInfo: this.$route.params.item,
                RepairInfo:{},
                AssignUserId:'',//指派维修工程师
                AudioUrl:'',
                WXDH:this.$route.params.item.RepairOrder||this.$route.params.item.OrderNo//OrderNo为消息列表传参
            }
        },
        mounted() {
             this.$get('/api/Repair/GetRepairInfo',{
                 RepairNo:this.WXDH,
                 Store:this.$UserInfo.UserId,
                 Token:'1235'
             }).then(result=>{
                 this.RepairInfo=result.RepairInfo;
                 const Images=result.RepairInfo.Images?result.RepairInfo.Images.split(','):'';
                 let ImageArray=[];
                 Images?Images.forEach(function(item,index){
                     item?ImageArray.push({url:item}):'';
                 }):'';
                 this.$Bus.$emit('YSRKDelete',ImageArray);
             })
        },
        methods: {
            dispatch() {//指派工程师
            if(!this.AssignUserId){
                this.$Toast('请选择工程师!')
                this.$scrollscreen('.box','end');
                return false;
            }
                this.$post('api/Dispatch/Assign',{
                    RepairOrder:this.WXDH,
                    AssignUserId:this.AssignUserId,
                    UserCode:this.$UserInfo.UserId,
                    LineNumber:1,
                    Store:this.$UserInfo.StoreCode,
                    EquCode:this.EquipmentInfo.EquCode,
                    RepairStatus:'1'
                }).then(result=>{
                    if(result.Status){
                         this.$Toast({
                             message:result.Msg,
                             duration:4000,
                             onClose:()=>{
                                 this.$Bus.$emit('Message',this.WXDH);
                                 this.$router.back();
                             }
                         });
                    }else this.$Toast(result.Msg);
                })
            },
            overlook() {//忽略
                this.$Dialog.confirm({
                    message:'确定忽略？'
                }).then(()=>{
                    this.$post('api/Dispatch/Ignore',{
                        RepairOrder:this.EquipmentInfo.RepairOrder,
                        UserCode:this.$UserInfo.UserId,
                        Token:'123456'
                    }).then(result=>{
                         if(result.Status){
                             this.$Toast('忽略成功!',1.5);
                             setTimeout(x=>{
                                 this.$router.go(-1);
                             },1000)
                         }
                    })
                }).catch(()=>{})
            }
        }
    }
</script>

<style scoped lang="scss">
    .box{
        padding-bottom: 114px;
    }
    .engineer{
        background: $BACKGROUND-COLOR;
        border-radius: 12px;
        padding: 36px 40px 55px;
        box-sizing: border-box;
        margin-bottom: 20px;
        .title{
            color: $TEXT-DARK-COLOR;
            font-size: 34px;
            font-weight: bold;
            margin-bottom: 30px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/page/dispatch/dispatch.vue